import React from "react";
import { Route, Switch } from "react-router-dom";

import { AccountsList, BulkImport } from "./accounts";
import { ImportLogsList } from "./import-logs";

export default () => {
    return {
        routes: [
            {
                path: "/babbage-accounts",
                render: ({ match }) => (
                    <Switch>
                        <Route
                            path={`${match.url}/import-logs`}
                            exact
                            component={ImportLogsList}
                        />
                        <Route
                            path={`${match.url}/import`}
                            exact
                            component={BulkImport}
                        />
                        <Route
                            path={`${match.url}`}
                            exact
                            component={AccountsList}
                        />
                    </Switch>
                ),
            },
        ],
    };
};
